import { useNavigate } from 'react-router-dom';

// creates a handler to navigate to a given URL
export const useNavigateHandler = (link: string) => {
  const navigate = useNavigate();

  return () => navigate(link);
};
